import axiosClient from "./axiosClient";

export const listarIngresos = (cuentaId, pagina = 1) =>
  axiosClient.get(`/ingresos/cuenta/${cuentaId}`, { params: { pagina } }).then((r) => r.data);
export const listarIngresosRecientes = (cuentaId, mes, anio) =>
  axiosClient.get(`/ingresos/cuenta/${cuentaId}/recientes`, { params: { mes, anio } }).then((r) => r.data);
export const listarHistoricoIngresos = (cuentaId, desde, hasta, pagina = 1) =>
  axiosClient.get("/ingresos/historico", { params: { cuentaId, desde, hasta, pagina } }).then((r) => r.data);
export const registrarIngreso = (data) => axiosClient.post("/ingresos", data).then((r) => r.data);
export const eliminarIngreso = (id) => axiosClient.delete(`/ingresos/${id}`);
